import * as ActionTypes from '../../actions/ActionTypes';
import ArticleVersionsRecord from '../../records/edit/ArticleVersionsRecord';
export default function articleVersions(state = new ArticleVersionsRecord(), action) {
  switch (action.type) {
    case ActionTypes.FETCH_ARTICLE_VERSIONS_SUCCESS:
      {
        const {
          payload
        } = action;
        if (payload.offset === 0) {
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
          return new ArticleVersionsRecord(payload).set('lastLoaded', Date.now());
        }
        return state.merge({
          objects: state.objects.concat(payload.objects),
          offset: payload.offset,
          error: null,
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
          lastLoaded: Date.now(),
          isRequesting: false
        });
      }
    case ActionTypes.FETCH_ARTICLE_VERSIONS_PENDING:
      return state.set('isRequesting', true);
    case ActionTypes.FETCH_ARTICLE_VERSIONS_ERROR:
      return state.merge({
        isRequesting: false,
        error: action.error
      });
    case ActionTypes.RESET_ARTICLE_DETAILS:
      return new ArticleVersionsRecord();
    default:
      return state;
  }
}